import {refreshDatagrid as refreshEagDatagrid} from 'features/eag-grid';

type RefreshDmsDatagridOptions = {
  deselectAll?: boolean;
  /**
   * When true, refreshes row counts displayed on preset buttons.
   */
  refreshPresetCount?: boolean;
};

/**
 * Refresh a grid by its gridCode.
 */
export const refreshDmsDatagrid = (gridCode: string, options?: RefreshDmsDatagridOptions): void => {
  refreshEagDatagrid(gridCode, options);
};
